import type { PetLossLocale } from '@paction-2.0/util/petLossReadiness';

import styles from './petLossReadinessPage.module.scss';

function EnglishIntro() {
  return (
    <div className={styles.intro}>
      <h2 className={styles.title}>
        <div className={styles.titleBold}>
          60.8% of prospective puppy owners
        </div>
        <div className={styles.titleText}>
          report that the loss of a previous dog is their primary motivation for
          beginning their search for a new pup
          <span className={styles.asterisk}>*</span>
        </div>
      </h2>
      <div className={styles.text}>
        <p>
          This insight highlights an important intersection between{' '}
          <strong>pet bereavement</strong> and{' '}
          <strong>responsible dog ownership</strong>.
        </p>
        <p>
          One of Paction&apos;s core missions is to support informed,
          responsible decisions throughout the entire dog ownership journey,
          including the decision to welcome a new dog after loss.
        </p>
        <p className={styles.reference}>
          <span className={styles.referenceAsterisk}>*</span>Among prospective
          puppy owners who voluntarily provided a reason for beginning their
          search. Paction anonymized survey data collected in 2026 from 6,989
          Canadian users
        </p>
      </div>
    </div>
  );
}

function FrenchIntro() {
  return (
    <div className={styles.intro}>
      <h2 className={styles.title}>
        <div className={styles.titleBold}>
          60,8 % des futurs propriétaires de chiots
        </div>
        <div className={styles.titleText}>
          affirment que la perte d&apos;un chien précédent est leur principale
          motivation pour commencer à chercher un nouveau chiot
          <span className={styles.asterisk}>*</span>
        </div>
      </h2>
      <div className={styles.text}>
        <p>
          Cette donnée met en lumière un lien important entre le{' '}
          <strong>deuil animalier</strong> et la{' '}
          <strong>possession responsable d&apos;un chien</strong>.
        </p>
        <p>
          L&apos;une des missions fondamentales de Paction est de favoriser des
          décisions éclairées et responsables tout au long de la vie avec un
          chien, y compris la décision d&apos;accueillir un nouveau chien après
          une perte.
        </p>
        <p className={styles.reference}>
          <span className={styles.referenceAsterisk}>*</span>Parmi les futurs
          propriétaires de chiots ayant indiqué volontairement la raison de leur
          recherche. Données de sondage anonymisées recueillies par Paction en
          2026 auprès de 6 989 utilisateurs canadiens
        </p>
      </div>
    </div>
  );
}

export function ReadinessIntro({ locale = 'en' }: { locale?: PetLossLocale }) {
  return locale === 'fr' ? <FrenchIntro /> : <EnglishIntro />;
}
